import { FileOperationsImplementation } from "@commoncore/implementation/FileOperationsImplementation";
import { ListViewImplementation } from "../implementation/ListViewImplementation";
import { GlobalService } from "../services/global.service";
import { Controller } from "./Controller";


export class ListViewController extends Controller{
  public listViewImplementation: any;
  public universalService: any;
  public static singleInstance: any = null;
  loggerService: any;
  public listService:any;
  fileOpsImplRef:any;

  public constructor(public globalService:GlobalService) {
    super(globalService);
    this.listViewImplementation = ListViewImplementation.getInstance(globalService);
    this.setEnvObjects(globalService);
  }

  public static getInstance(globalService): ListViewController {
    if (this.singleInstance == null) {
      this.singleInstance = new ListViewController(globalService);
      return this.singleInstance;
    } else {
      return this.singleInstance;
    }
  }


  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.loggerService = globalService.getLoggerServiceRef();
    this.listService = globalService.getListServiceRef();
    this.fileOpsImplRef = FileOperationsImplementation.getInstance(globalService);

  }


  async setRecentFilesListView(recentFiles){
    try{
        await this.listViewImplementation.setRecentFilesListview(recentFiles);
    }catch(exc){
        this.loggerService.log("exception in setting recent files list view",exc);
    }
  }

  async onSelectionChanged(event){
    var result ;
    result = await this.listViewImplementation.onSelectionChanged();
    return result;
  }


  async updateUIAfterPerformingAction(list,executedTask){
    this.loggerService.log("row data is ==>>",this.listViewImplementation.rowData);
    if(executedTask == "MOVE" && this.universalService.selectedFolder && this.universalService.selectedFolder.objectName == 'Private Folder')
      executedTask = "MOVETOPF"
    if((this.universalService.currentTab == 'docs' || this.universalService.currentTab == 'audio' || this.universalService.currentTab == 'Search Results'
        || this.universalService.fetchAllRecentFiles || window.location.href.indexOf("/favorites/myfiles") > -1) && this.universalService.listView && executedTask == "MOVE"){
      this.universalService.showLoader = false;
      this.universalService.popUpToBeOpened = "";
      this.listService.deSelectAll(null);
      return;
    }else if(executedTask == 'TRASH' || executedTask == "MOVE" || executedTask == "MOVETOPF" ){
        this.listViewImplementation.setHandler(this.globalService);
        await this.listViewImplementation.updateSummaryCountsAndUI(list,this.listViewImplementation.indexsArray,executedTask);
        if( this.universalService.currentTab == "Favorites" && this.listService.listOptions.api.getDisplayedRowCount()==0){
          this.universalService.emptyFav = true 
        }
        if(executedTask == "MOVETOPF"){
          this.fileOpsImplRef.addToDBForMoveCopy(null, executedTask)
        }
        if(this.listService.listOptions.api.getDisplayedRowCount()==0) return "empty";
    }else if((executedTask == 'RENAME' || executedTask == 'SETFAV' || executedTask == 'UNSETFAV' || executedTask == 'FRN' || executedTask == "SHAREPERMISSION")){
        this.listViewImplementation.setHandler(this.globalService);
        this.listViewImplementation.updateOnlyTheUI(list,executedTask)
    }else{
        this.loggerService.log("task invalid",executedTask)
    }

}

clearIndexArray(){
  this.listViewImplementation.clearIndexArray();
}

addToIndexArray(index){
  this.listViewImplementation.indexsArray = [index];
  this.universalService.listIndexOnPreview = index;
}



}